var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPreDrawCardDisabled(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 95,
    height: 122,
    viewBox: "0 0 95 122",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.2
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.27735 4.39374C1.09413 23.2015 0.000234679 42.0965 2.02332e-05 61.0039C-0.00443616 79.9025 1.08361 98.7888 3.25985 117.588L3.40564 118.868L5.00931 119.085C33.2208 122.972 61.9382 122.972 90.1496 119.085L91.5783 118.888L91.7241 117.614C96.092 79.9737 96.092 42.0342 91.7241 4.39374L91.5783 3.11433L90.1496 2.9175C61.8857 -0.972502 33.1158 -0.972504 4.85186 2.9175L3.42314 3.11433L3.27735 4.39374Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M14.1996 18.0483C12.5658 32.267 11.7472 46.5516 11.747 60.8456C11.7437 75.1329 12.5579 89.411 14.1865 103.623L14.2956 104.591L15.4958 104.755C36.6083 107.693 58.0994 107.693 79.2119 104.755L80.2811 104.606L80.3902 103.643C83.659 75.1868 83.659 46.5045 80.3902 18.0483L80.2811 17.0811L79.2119 16.9323C58.0602 13.9915 36.5297 13.9915 15.3779 16.9323L14.3087 17.0811L14.1996 18.0483Z",
    fill: "#EEEEE4"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreDrawCardDisabled);
export default __webpack_public_path__ + "static/media/preDrawCardDisabled.2ec12aa138cfa3b578b05e5bdabfa082.svg";
export { ForwardRef as ReactComponent };